const printContentById = (printDivId, printHeader) => {
    const printElement = document.getElementById(printDivId);
    if (printElement) {
        const printContent = printElement.innerHTML;
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        const printDocument = iframe.contentWindow.document;

        // Basic inline styles for the printed content
        const basicStyles = `
            <style>
            @media print {
                  .exclude-from-print {
                    display: none;
                  }
                }
                table {
                  width: 10%;
                  border-collapse: collapse;
                }               
                title {
                  font-weight: bold;
                }
                body {
                    font-family: Arial, sans-serif;
                    font-size: 12px;
                }              
                th, td {
                  border: 1px solid black;
                  padding: 1px;
                }               
                h3 {
                    font-weight: bold;
                    text-align: center;
                }
                .card {
                    border: 1px solid #ccc;
                    border-radius: 6px;
                    padding: 10px;
                    margin: 10px;
                }
             col {
                  width: 50%;
                  border-collapse: collapse;
                }   
                .col-sm-8{-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}  
              .card-header{padding:.75rem 1.25rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}
              .card-header{border-radius:0;margin-bottom:-1px;font-weight: bold;}
              .card-header{border-bottom:none;padding:0;border-radius:.125rem}
              .card-header{background:#fff;border-bottom:0;display:-ms-flexbox;display:flex;padding:1.25rem 1.25rem 0}
              .card-body{-ms-flex:1 1 auto;flex:1 1 auto;min-height:1px;padding:1.25rem}
              .card-body{padding:0 1rem 1.5rem 2.75rem}@media (min-width:768px){.uxf-accordion .card-body{padding:0 1.5rem 1.5rem 2.75rem}}
              .uxf-dl{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}
              .uxf-dl dt{margin-right:.25rem;width:50%;font-weight: bold;}
              .uxf-dl dd{width:50%; }
              .w-100{width:100%!important}
              .row{margin:0}
              .row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}      
              .col{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}
            </style>
        `;

        printDocument.write(`
          <html>
            <head>
              <title></title>
              ${basicStyles}
            </head>
            <body>
              <h3>${printHeader}</h3>
              <div>${printContent}</div>
            </body>
          </html>
        `);

        printDocument.close();
        iframe.contentWindow.print();
    }
}

export { printContentById };
